import { Group, Home, Person, Settings, StickyNote2 } from '@mui/icons-material'
import React, { useEffect, useState } from 'react'

export default function Team() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [screenshots, setScreenShots] = useState([
    {
      id: 0,
      heading: "Effortlessly manage your business with an intuitive dashboard:",
      content: "Track customers, assets, bookings, invoices, and monitor growth trends through monthly booking insights and graphs.",
      image: "assets/software-screenshots/dashboard.png",
    },
    {
      id: 1,
      heading: "Manage all your users seamlessly in one place:",
      content: "Add, update, and oversee user profiles to ensure smooth business operations with detailed insights and management tools.",
      image: "assets/software-screenshots/users.png",
    },
    {
      id: 2,
      heading: "Keep track of your assets effortlessly:",
      content: "Monitor, maintain, and update your heavy machinery inventory, ensuring optimal utilization and uptime.",
      image: "assets/software-screenshots/assets.png",
    },
    {
      id: 3,
      heading: "Streamline customer management like never before:",
      content: "Access detailed customer profiles, track interactions, and enhance relationships for better retention and satisfaction.",
      image: "assets/software-screenshots/customers.png",
    },
    {
      id: 4,
      heading: "Efficiently manage your bookings with intuitive tools:",
      content: "View, track, and update bookings while monitoring schedules and trends for improved operational efficiency.",
      image: "assets/software-screenshots/bookings.png",
    }
  ])

  useEffect(() => {

  }, [activeIndex, setActiveIndex])
  return (
    <section className="team-style-two text-center bg-color-2">
      <div
        className="pattern-layer"
        // style={{ backgroundImage: "url(assets/images/icons/pattern-19.png)" }}
      />
      <div className="container-fluid px-5">
        <div className="sec-title light">
          <div className="title-two">
            <p>
              <span>{"{"}</span>&nbsp;Software Overview&nbsp;<span>{"}"}</span>
            </p>
          </div>
          <h3>
            Explore the power and simplicity of our software in action.
          </h3>
        </div>
        <div className='row clearfix' style={{ marginTop: "-25px" }}>
          <div className="col-lg-10 col-md-10 col-sm-10 offset-1"
            style={{ border: "1px solid #fff", borderRadius: "10px", padding: "20px", display: "flex", justifyContent: "space-evenly" }}>
            <div onClick={() => setActiveIndex(0)} className="soft-over-item d-flex align-items-center">
              <Home className={`soft-${activeIndex === 0 ? "current-overview active-option" : ""}`} />
              <span className={`ml-1 soft-${activeIndex === 0 ? "current-overview active-option" : ""}`}>Dashboard</span>
            </div>

            <div onClick={() => setActiveIndex(1)} className="soft-over-item d-flex align-items-center">
              <Person className={`soft-${activeIndex === 1 ? "current-overview active-option" : ""}`} />
              <span className={`ml-1 soft-${activeIndex === 1 ? "current-overview active-option" : ""}`}>Users</span>
            </div>

            <div onClick={() => setActiveIndex(2)} className="soft-over-item d-flex align-items-center">
              <Settings className={`soft-${activeIndex === 2 ? "current-overview active-option" : ""}`} />
              <span className={`ml-1 soft-${activeIndex === 2 ? "current-overview active-option" : ""}`}>Assets</span>
            </div>

            <div onClick={() => setActiveIndex(3)} className="soft-over-item d-flex align-items-center">
              <Group className={`soft-${activeIndex === 3 ? "current-overview active-option" : ""}`} />
              <span className={`ml-1 soft-${activeIndex === 3 ? "current-overview active-option" : ""}`}>Customers</span>
            </div>

            <div onClick={() => setActiveIndex(4)} className="soft-over-item d-flex align-items-center">
              <StickyNote2 className={`soft-${activeIndex === 4 ? "current-overview active-option" : ""}`} />
              <span className={`ml-1 soft-${activeIndex === 4 ? "current-overview active-option" : ""}`}>Bookings</span>
            </div>

          </div>
        </div>
        {
          screenshots && screenshots.length > 0 && screenshots.map(item => (
            activeIndex == item.id &&
            <div key={item.id} className="row clearfix" style={{ marginTop: "90px" }}>
              <div className="col-lg-4 col-md-6 col-sm-12 offset-1 mt-5">
                <p className='animated-text' style={{ fontWeight: "bold", fontSize: "2vw", color: "#fff", wordSpacing: "10px", lineHeight: "2.1vw", textAlign: "left" }}>{item.heading} </p>
                <p style={{ fontSize: "1vw", color: "#fff", wordSpacing: "1px", lineHeight: "1.4vw", textAlign: "left" }} className='text-white mt-3 animated-text'>
                  {item.content}
                </p>
              </div>
              <div className="col-lg-7 col-md-6 col-sm-12 wow fadeInUp">
                <img
                  className="image-box"
                  style={{
                    width: "40vw",
                    height: "17vw",
                    boxShadow: "#fff 1px 1px 30px 0",
                  }}
                  src={item.image}
                  alt=""
                />
              </div>
              {/* <div className="col-lg-3 col-md-6 col-sm-12 team-block">
                <div
                  className="team-block-two wow fadeInUp"
                  data-wow-delay="600ms"
                  data-wow-duration="1500ms"
                >
                  <div className="inner-box">
                    <figure className="image-box">
                      <a >
                        <img src="assets/images/resource/team-2.jpg" alt="" />
                      </a>
                    </figure>
                    <div className="lower-content">
                      <div className="box">
                        <h5>
                          <a >Dummy Dummy</a>
                        </h5>
                        <span className="designation">Chief Executive</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
          ))
        }
      </div >
    </section >
  )
}
